<template>
  <UPageCard
    reverse
    class="w-full max-w-3xs overflow-x-auto"
    :ui="{
      container: 'p-0 sm:p-0',
      body: 'w-full',
    }"
  >
    <div class="aspect-square overflow-hidden">
      <NuxtImg
        v-if="post.content?.coverImg?.filename"
        :src="post.content?.coverImg.filename"
        :alt="post.content?.title"
        class="w-full"
        fit="in"
        height="336"
        width="336"
        :modifiers="{ filters: { fill: 'transparent' } }"
        :provider="
          post.content?.coverImg.filename.includes('a.storyblok.com')
            ? 'storyblok'
            : undefined
        "
      />
      <USkeleton v-else class="w-full h-full" />
    </div>
    <template #title>
      <h4 class="text-2xl text-primary font-bold text-center">
        {{ post.content?.title ?? post.name }}
      </h4>
    </template>
    <template #description>
      <div
        class="text-center max-h-24 h-24 text-sm leading-5 line-clamp-5 overflow-y-hidden"
      >
        <span
          v-for="(line, lineIdx) of (post.content?.description ?? '').split(
            '\n',
          )"
          :key="lineIdx"
          class="block"
          >{{ line }}</span
        >
      </div>
    </template>
    <template #footer>
      <UButton :to="`/${post.full_slug}`" variant="ghost"
        >Prohlédnout si<UIcon name="i-lucide-move-right" class="ml-2"
      /></UButton>
    </template>
  </UPageCard>
</template>
<script setup lang="ts">
type TGalleryCard = {
  title: string;
  description: string;
  coverImg: { filename: string };
};
defineProps<{
  post: { content: TGalleryCard; full_slug: string; name: string };
}>();
</script>
